import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getAllPages, getBottomMenu, getOttSettings, getPage } from "../../../Api/api";
import { utility } from "../../../utility/utility";
import { useFocusable, FocusContext } from '@noriginmedia/norigin-spatial-navigation';
import { MainPage } from '../../MainPage';
import useSocket from "../../../socket/useSocket";
import { DISPLAYPLATFORM, LOCAL_STORAGE_KEY, MODULE, SOCKET_ACTION, SOCKET_EVENTS } from "../../../constant";
import MainWrapper from "../../MainWrapper";
import { useDispatch, useSelector } from "react-redux";
import { fetchInitialData, setPrevPath, setSelectedProfile } from "../../../redux/applicationSlice";
import { PlatformContext } from "../../../contexts/platformContext";
import { handleForegroundMessages, subscribeUserToTopics } from "../../../firebase/firebaseHelper";
import AnalyticsManager from "../../../analytics/analyticsManager";

const Preview = (props) => {
    const { displayPlatform } = props;
    const isMobile = displayPlatform === DISPLAYPLATFORM.MOBILE;

    const [page, setPage] = useState([]);
    const [menu, setMenu] = useState([]);
    const [loading, setLoading] = useState(true);
    const [ottSetting, setOttSetting] = useState({});
    const location = useLocation();
    const isOpenPiPage = location?.state?.isOpenPiPage ?? false;
    const { ref, focusKey } = useFocusable();
    const { user, logo, theme, profiles, selectedProfile, editedProfile, ottSettings } = useSelector((state) => state.application);
    const savedProfile = utility.getValue(LOCAL_STORAGE_KEY.selectedProfile);
    const hashPath = window.location.hash.replace(/^#/, '');

    function getQueryVariable() {
        var query = window.location.href;
        let index = query.indexOf('=');
        if (index >= 0) {
            query = query.substring(index + 1);
            return query;
        } else {
            return '';
        }
    }

    const pageIdFromQuery = getQueryVariable()?.toString();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!ottSettings) {
            dispatch(fetchInitialData());
        }
    }, [dispatch])

    useEffect(() => {
        loadData();
    }, [location?.state?.page])

    useEffect(() => {
        if (savedProfile && !selectedProfile) {
            dispatch(setSelectedProfile(savedProfile));
            return;
        }

        if (user && !selectedProfile && !ottSettings?.disableProfileSelection && profiles?.length > 0) {
            dispatch(setPrevPath(hashPath));
            navigate('/profile');
        }

        if (user) {
            subscribeUserToTopics(user)
            handleForegroundMessages()
        }
    }, [user, selectedProfile, profiles, ottSettings]);


    const getPageFromQuery = async () => {
        if (pageIdFromQuery) {
            let res = await getPage(pageIdFromQuery)
            if (res.success) {
                setPage(res.data);
            }
        }
        const ottSettingRes = await getOttSettings();
        if (ottSettingRes.success) {
            console.log(ottSettingRes);
            setOttSetting({ ...ottSettingRes.data, piPageSetting: ottSettingRes?.piPageSetting });
        }
    }



    //socket
    const socket = useSocket(SOCKET_EVENTS.onSocketData, (socketData) => {

        if (socketData.module != MODULE.PLATFORM) return;
        console.log(socketData);
        switch (socketData.action) {
            case SOCKET_ACTION.PLATFORM_THEME_REFRESH:
            case SOCKET_ACTION.PLATFORM_GRID_REFRESH:
                loadOttSettings();
                break;
            case SOCKET_ACTION.PLATFORM_RAIL_REFRESH:
            case SOCKET_ACTION.PLATFORM_PAGE_REFRESH:
                loadData();
                break;
            default:
                break;
        }
    });

    const loadData = async () => {
        setLoading(true);
        if (pageIdFromQuery && pageIdFromQuery?.length > 0) {
            await getPageFromQuery();
        } else if (location.state && location.state.page) {
            let pageRes = await getPage(location.state.page._id);
            if (pageRes.success) {
                setPage(pageRes.data);
                await loadOttSettings();
            } else {
                setPage(location.state.page);
            }
        } else {
            await loadOttSettings();
        }
        setLoading(false);
    }

    const loadLayout = async (settings) => {

        let pageID = settings.homePage

        if (settings.showBottomMenu) {
            const bottomMenuRes = await getBottomMenu();
            const allPages = await getAllPages();
            if (allPages.success) {
                console.log(allPages);
                utility.setValue(LOCAL_STORAGE_KEY.pages, allPages.data)
            }
            console.log(bottomMenuRes)
            setMenu(bottomMenuRes.data.Pages);
            if (bottomMenuRes.success) {
                if (bottomMenuRes.data.Pages && bottomMenuRes.data.Pages.length > 0) {
                    pageID = bottomMenuRes.data.Pages[0]._id
                }
            }
        }

        const response = await getPage(pageID);
        if (response.success) {
            setPage(response.data);
        }


    }

    const loadOttSettings = async () => {
        const ottSettingRes = await getOttSettings();
        console.log(ottSettingRes);
        if (ottSettingRes.success) {
            setOttSetting({ ...ottSettingRes.data, piPageSetting: ottSettingRes?.piPageSetting });
            await loadLayout(ottSettingRes.data);
            // Analytics Provider
            if (ottSettingRes?.data?.analyticsProvider) {
                AnalyticsManager().init(ottSettingRes?.data?.analyticsProvider);
            }
        }
    }

    return loading ?
        <div style={{ height: "100vh", width: "100vw", display: "flex", justifyContent: "center", alignItems: "center", overflow: 'hidden' }}>
            <span style={{ position: "fixed", top: "7px", left: "50%", transform: "translate(-50%, 0)", backgroundColor: "#FFF9C9", padding: "3px 7px", fontWeight: "bold", fontSize: "13px", boxShadow: "0 3px 3px rgba(0,0,0,0.23)" }}>
                Loading ...
            </span>
            <i style={{ fontSize: "42px" }} className="fa fa-spin fa-spinner" />
        </div>
        : <PlatformContext.Provider value={displayPlatform}>
            <FocusContext.Provider value={focusKey}>
                <MainWrapper focusKeyParam="CONTAINER"
                    page={page} ottSetting={ottSetting} menu={menu} isOpenPiPage={isOpenPiPage} pageState={location.state} />
            </FocusContext.Provider>
        </PlatformContext.Provider>
}

export default Preview;